import PropTypes from 'prop-types';

export const BreadcrumbsComponentTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        to: PropTypes.string,
        onClick: PropTypes.func,
        icon: PropTypes.elementType,
      })
    ).isRequired,
    separator: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    maxItems: PropTypes.number,
    activeLastBreadcrumb: PropTypes.bool,
    showIcons: PropTypes.bool,
    style: PropTypes.object,
    color: PropTypes.string,
    separatorColor: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
  };